import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Draft} from "../../../../../model/Draft";
import {Item} from "../../../../../model/cart/Item";
import {StartupService} from "../../../../service-ui/startup.service";
import {Router} from "@angular/router";
import {ResourceService} from "../../../../service-data/resource.service";
import {MatDialog} from "@angular/material/dialog";
import {DraftService} from "../../../../service-data/draft.service";
import {LanguagePipe} from "../../../../pipe/language.pipe";
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {Project} from "../../../../../model/Project";
import {Book} from "../../../../../model/Book";
import {MoveProjectComponent} from "../../project/dialogs/move-project/move-project.component";
import {ProjectService} from "../../../../service-data/project.service";
import {ReasignDraftComponent} from "../../project/dialogs/reasign-draft/reasign-draft.component";
import {Resource} from "../../../../../model/Resource";
import {PaperTypeService} from "../../../../service-data/paper-type.service";
import {ResourceStatus} from "../../../../service-ui/resource-status";
import {modernDialogConfig} from "../../../../service-ui/dialog-config";

@Component({
  selector: 'app-project-draft-thumbnail',
  templateUrl: './project-draft-thumbnail.component.html',
  styleUrls: ['./project-draft-thumbnail.component.css']
})
export class ProjectDraftThumbnailComponent implements OnInit, OnChanges {
  @ViewChild('draftCoverImage', { static: true }) draftCoverImage;
  @Input() draft: Draft;
  @Output() selectedItem = new EventEmitter<Project | Draft | Book>();
  @Output() editingDetailsChange = new EventEmitter<string>();

  displayScale = 1.0;
  editingTitle = false;

  /** The inline title editor, present only while 'editingTitle'. */
  @ViewChild('titleInput') titleInput;


  Math = Math;
  private requestedResources = new Set<number>();

  constructor(public router: Router, public startupService: StartupService, private projectService: ProjectService, private resourceService: ResourceService, private draftService: DraftService, public paperTypeService: PaperTypeService, public dialog: MatDialog) {
  }

  ngOnInit() {
    // this.refreshImagePosition();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('Change ', changes);
    // this.refreshImagePosition();
  }

  // refreshImagePositionDetails(cachedImage: any) {
  //   this.draftCoverImage.nativeElement.style.display = "block";
  //   this.draftCoverImage.nativeElement.src = cachedImage.src;
  //
  //   let naturalWidth = cachedImage.naturalWidth;
  //   if ( !naturalWidth ) {
  //     naturalWidth = cachedImage.width;
  //   }
  //
  //   let naturalHeight = cachedImage.naturalHeight;
  //   if ( !naturalHeight ) {
  //     naturalHeight = cachedImage.height;
  //   }
  //
  //   // var clipWidth = ((bookBody.pageSize.width)*2+(paperWeights[paperWeights.usedWeight].caliper*bookBody.pages.numberOfPages/2*dpi) + this.trimWobble)*bookBody.displayScale.value+2*this.bleed;
  //   // var clipHeight = ((bookBody.pageSize.height + this.trimWobble)*bookBody.displayScale.value)+2*this.bleed;
  //   const clipWidth = this.draftCoverImage.nativeElement.parentNode.clientWidth - 2; // - 2 for border thickness
  //   const clipHeight = this.draftCoverImage.nativeElement.parentNode.clientHeight - 2;
  //
  //   const pageScreenWidth = ( naturalWidth * this.displayScale * this.draft.draftCover.documentScale);
  //   if ( pageScreenWidth ) {
  //     this.draftCoverImage.nativeElement.style.width = pageScreenWidth + 'px';
  //     const pageScreenHeight = ( naturalHeight * this.displayScale * this.draft.draftCover.documentScale);
  //
  //     this.draftCoverImage.nativeElement.style.height = pageScreenHeight + 'px';
  //
  //     this.draftCoverImage.nativeElement.style.left = ( ( clipWidth - pageScreenWidth ) / 2 + this.draft.draftCover.horizontalShift * this.displayScale ) + 'px';
  //     this.draftCoverImage.nativeElement.style.top = ( ( clipHeight - pageScreenHeight ) / 2 - this.draft.draftCover.verticalShift * this.displayScale ) + 'px';
  //
  //     this.draftCoverImage.nativeElement.style.width = '436px';
  //     this.draftCoverImage.nativeElement.style.height = '297px';
  //     this.draftCoverImage.nativeElement.style.left = '-230px';
  //     this.draftCoverImage.nativeElement.style.top = '0px';
  //
  //   }
  // }
  //
  // refreshImagePosition() {
  //   if ( !this.draft.draftCover ) {
  //     return;
  //   }
  //   let resourceId = this.draft.draftCover.resource_ID;
  //   let bodyOrCover = 'COVER';
  //   if ( this.draft.bindingType === 'SADDLE_STITCH' ) {
  //     resourceId = this.draft.draftBody.resource_ID;
  //     bodyOrCover = 'BODY';
  //   }
  //
  //   if ( !resourceId ) {
  //     this.draftCoverImage.nativeElement.src = '';
  //     return;
  //   }
  //
  //   // let imageUrl;
  //   let imageId;
  //   switch ( bodyOrCover ) {
  //     case 'COVER': {
  //       imageId = 'resource-' + this.draft.draftCover.resource_ID;
  //       break;
  //     }
  //     case 'BODY': {
  //       imageId = 'resource-' + this.draft.draftBody.resource_ID;
  //       break;
  //     }
  //   }
  //   let cachedImage: any = document.getElementById(imageId);
  //   if ( !cachedImage ) {
  //     const hiddenImagesElement: any = document.getElementById('hiddenImages');
  //     if ( hiddenImagesElement ) {
  //       const imageElement = document.createElement("img");
  //       this.resourceService.getImageURL(resourceId, 'COLOR', 72, 1).subscribe( imageURL => {
  //         if ( imageURL ) {
  //           console.log(`Getting image for resourceId: ${resourceId} 'COLOR' 72 1 ${imageURL}`);
  //           imageElement.src = imageURL;
  //           imageElement.id = 'resource-' + resourceId;
  //           hiddenImagesElement.appendChild(imageElement);
  //           cachedImage = imageElement;
  //           imageElement.src = imageURL;
  //           if (cachedImage.complete ) {
  //             this.refreshImagePositionDetails(cachedImage);
  //           } else {
  //             cachedImage.addEventListener('load', _ => {
  //               this.refreshImagePositionDetails(cachedImage);
  //             });
  //             cachedImage.addEventListener('error', _ => {
  //               console.log(`Error loading image ${'resource-' + resourceId}`);
  //             });
  //           }
  //         }
  //       });
  //
  //       imageElement.id = imageId;
  //       hiddenImagesElement.appendChild(imageElement);
  //       cachedImage = imageElement;
  //     }
  //   }
  //   if ( cachedImage ) {
  //     if (cachedImage.complete ) {
  //       this.refreshImagePositionDetails(cachedImage);
  //     } else {
  //       cachedImage.addEventListener('load', _ => {
  //         this.refreshImagePositionDetails(cachedImage);
  //       });
  //       cachedImage.addEventListener('error', _ => {
  //         console.log(`Error loading image ${imageId}`);
  //       });
  //     }
  //   }
  // }

  /**
   * Emit the Draft itself, not `draft.project`.
   *
   * The parent stores the Project for the grid, but the detail pane used to
   * render `selectedItem.primaryDraft` - so opening any non-primary tile
   * silently showed the primary Draft instead of the one that was clicked.
   * `ProjectsComponent.selectedItemChanged` unpacks the union.
   */
  open(draft: Draft) {
    this.selectedItem.emit(draft);
    this.editingDetailsChange.emit('DRAFT');
  }

  makePrimary(draft: Draft, element: any ) {
    element.classList.add('spinner');
    this.projectService.setDraftAsPrimary(draft.project.ID, draft.ID).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  makeBook(draft: Draft, element: any ) {
    element.classList.add('spinner');
    this.projectService.makeDraftIntoBook(draft.ID, false).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  copy(draft: Draft, element: any ) {
    element.classList.add('spinner');
    this.draftService.copy(draft.ID).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  deleteDraft (draft: Draft, element: any ): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        name: draft.title,
        title: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.title + LanguagePipe.get('?', 'compressSpaces'),
        body: '', // LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.name + LanguagePipe.get('?', 'compressSpaces'),
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.title,
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed. result[' + result + ']');
      if ( result && result === 'ok' ) {
        this.draftService.deleteItem(draft).subscribe( proj => {
          console.log('Deleted a draft');
        });
      }
    });

  }

  createNewProjectWithDraft(draft: Draft, element: any ) {
    element.classList.add('spinner');
    this.projectService.createNewProjectWithDraft(draft.ID, draft.title).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  changeProject(draft: Draft, element: any ) {
    // modernDialogConfig, not `new MatDialogConfig()` — see
    // service-ui/dialog-config.ts: a constructed config drops the
    // app-wide `modern-dialog` skin.
    const dialogConfig = modernDialogConfig({ width: '640px' });
    dialogConfig.data = { draft: draft, projects: this.projectService.objects, folders: this.startupService.getCurrentOrganization().getProjectFolders() };
    const dialogRef = this.dialog.open(ReasignDraftComponent, dialogConfig);
  }

  moveProject(project: Project, element: any ) {
    const dialogConfig = modernDialogConfig();
    dialogConfig.width = '640px';
    dialogConfig.disableClose = false;
    dialogConfig.data = { organization: this.startupService.getCurrentOrganization(), project: project };
    const dialogRef = this.dialog.open(MoveProjectComponent, dialogConfig);
  }

  addToCart(draft: Draft) {
    const item: Item = this.startupService.getCart().addDraftItem(draft, 1);
    // this.bookService.getBookProperties(project).then( projectProperties => {
    //   const item: Item = this.startupService.getCart().add(projectProperties as DraftProperties);
    //   // item.setDraftProperties(projectProperties as DraftProperties);
    // });
  }

  /**
   * True when BOTH sides of the Draft have a Resource that is loaded, not
   * XPS, and fully prepared.
   *
   * Two defects fixed here, both of which fired when a `resource_ID` was 0
   * or its Resource had not been fetched yet:
   *
   * - **The guards and the dereferences were crossed.** The first branch
   *   tested `draftCover` and then read `draftBody`'s Resource; the second
   *   tested `draftBody` and read `draftCover`'s. A Draft with a cover
   *   Resource but no body Resource therefore passed the test and then threw
   *   `Cannot read properties of undefined (reading 'type')`.
   * - **`draft.draftBody` was dereferenced without being checked at all**, so
   *   a Draft carrying only a cover threw one line earlier still.
   *
   * This is bound to `[disabled]` in the template, so it re-evaluates on every
   * change-detection pass - the throw repeated for as long as the thumbnail
   * stayed on screen.
   *
   * The template binds `[disabled]="!canBookBeMade(draft)"`. It used to bind
   * the un-negated call, which disabled "Make Book" in precisely the case
   * where the book COULD be made, and offered it in every case where it could
   * not. Corrected 2026-10-24.
   */
  canBookBeMade(draft: Draft): boolean {
    return this.isSideResourceReady(draft && draft.draftCover)
        && this.isSideResourceReady(draft && draft.draftBody);
  }

  /**
   * A side (`draftCover` / `draftBody`) is ready when it has a real
   * `resource_ID`, that Resource is already loaded, and it is a prepared
   * non-XPS file.
   *
   * `resource_ID` of 0 means "no file uploaded yet" and is never ready - it is
   * also not worth a fetch, which is why this reads the cache and does not
   * call `getItem()`.
   */
  private isSideResourceReady(side: any): boolean {
    if ( !side || !side.resource_ID ) {
      return false;
    }
    const resource: Resource = this.resourceService.objectsById['' + side.resource_ID];
    if ( !resource ) {
      return false;
    }
    return resource.type !== 'XPS' && resource.prepared === 'COMPLETE';
  }

  // ── Inline title editing ──
  /**
   * Rename from the overflow menu.
   *
   * Focus has to be applied in a setTimeout: the input does not exist
   * until Angular has re-rendered the *ngIf this flag controls.
   *
   * 'startEditTitle' finds the same input by walking up from its own
   * event target, which a menu click cannot do — mat-menu renders its
   * panel in an overlay at the end of the body, nowhere near
   * '.pt-title-bar'. Hence the ViewChild.
   */
  startRename(): void {
    this.editingTitle = true;
    setTimeout(() => {
      const input = this.titleInput && this.titleInput.nativeElement;
      if ( input ) { input.focus(); input.select(); }
    });
  }

  startEditTitle(event: Event) {
    event.stopPropagation();
    this.editingTitle = true;
    setTimeout(() => {
      const input = (event.target as HTMLElement).closest('.pt-title-bar')?.querySelector('.pt-title-input') as HTMLInputElement;
      if (input) { input.focus(); input.select(); }
    });
  }

  commitTitle(value: string) {
    const trimmed = value.trim();
    this.editingTitle = false;
    if (trimmed && trimmed !== this.draft.title) {
      this.draft.title = trimmed;
      this.draftService.updateItem(this.draft).subscribe();
    }
  }

  cancelTitle(input: HTMLInputElement) {
    input.value = this.draft.title || '';
    this.editingTitle = false;
  }

  // ── Helper methods (matching ClassicProjectThumbnail) ──
  getDaysOldString(date: Date | string): string {
    const days = this.getDaysOld(date);
    if (days > 365) {
      const y = Math.floor(days / 365);
      const d = days % 365;
      return y + 'y ' + d + 'd';
    }
    return days + 'd';
  }

  getDaysOld(date: Date | string): number {
    if (!date) { return 0; }
    return Math.floor((new Date().getTime() - new Date(date).getTime()) / (1000 * 60 * 60 * 24));
  }

  formatTrim(width: number, height: number): string {
    if (!width || !height) { return ''; }
    return this.localizeNumber((Math.round((width / 72) * 100) / 100)) + 'x' + this.localizeNumber((Math.round((height / 72) * 100) / 100));
  }

  formatShift(shift: number): string {
    if (shift == null || shift === undefined) { return this.localizeNumber('0.00'); }
    return this.localizeNumber((Math.round((shift / 72) * 100) / 100).toFixed(2));
  }

  formatScale(scale: number): string {
    if (scale == null || scale === undefined) { return this.localizeNumber('100') + '%'; }
    return this.localizeNumber((Math.round(scale * 100))) + '%';
  }

  localizeNumber(value: any): string {
    return LanguagePipe.localizeNumber(value);
  }

  // --- Resource id badge -------------------------------------------
  // All four components that render this badge take the SIDE object
  // (cover / body / draftCover / draftBody) rather than a bare
  // resource_ID, so one signature covers both the Draft case (no
  // `standardized` field) and the Book case (has one). See
  // src/app/service-ui/resource-status.ts.

  getResourceStatusColor(side: any): string {
    return ResourceStatus.fill(!!(side && side.resource_ID), this.resourceFor(side && side.resource_ID));
  }

  /**
   * Stripe colour for the standardized stage.
   *
   * Always resolves to `'none'` here, and that is correct rather than a
   * stub: `DraftCover` / `DraftBody` have no `standardized` field at all
   * - standardization is a Book-side stage. The binding is present so
   * the Draft badge and the Book badge are the same element with the
   * same three channels; the Draft simply has nothing to put in the
   * second one. That is what keeps the two views consistent without
   * inventing a status a Draft does not have.
   */
  getResourceStripe(side: any): string {
    return ResourceStatus.stripe(this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  isResourceActionable(side: any): boolean {
    return ResourceStatus.isActionable(this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  getResourceDisplayString(side: any): string {
    return ResourceStatus.displayString(side && side.resource_ID);
  }

  getResourceHoverText(side: any, label: string): string {
    return ResourceStatus.hoverText(label, !!(side && side.resource_ID),
      this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  /**
   * Advance the resource from INITIAL to WAITING, queueing preparation.
   *
   * `stopPropagation` because the badge sits inside a thumbnail card
   * whose other regions navigate; without it, asking for preparation
   * would also open the draft.
   */
  onResourceBadgeClick(side: any, event: Event): void {
    if (event) { event.stopPropagation(); }
    const res = this.resourceFor(side && side.resource_ID);
    // Drafts only ever have the PREPARE stage available.
    if (ResourceStatus.action(res) !== 'PREPARE') {
      return;
    }
    res.prepared = 'WAITING';
    this.resourceService.updateItem(res).subscribe();
  }

  /**
   * Resolve a Resource, fetching it once if it is not loaded.
   *
   * ResourceService is not loaded at startup, so the row usually is not
   * there on first paint. `requestedResources` is what stops that
   * becoming a request storm: this is called from template getters,
   * re-evaluated on every change-detection pass, so an unguarded
   * `getItem()` would fire one HTTP call per tick until the row landed.
   */
  private resourceFor(resource_ID: number): Resource {
    if (!resource_ID) {
      return null;
    }
    const res = this.resourceService.objects.find(r => r.ID === resource_ID);
    if (!res) {
      if (!this.requestedResources.has(resource_ID)) {
        this.requestedResources.add(resource_ID);
        this.resourceService.getItem(resource_ID).subscribe();
      }
      return null;
    }
    return res;
  }

  getPaperTypeName(paperType_ID: number): string {
    if (!paperType_ID) { return ''; }
    const pt = this.paperTypeService.objects.find(p => p.ID === paperType_ID);
    if (pt) { return LanguagePipe.get(pt.name, 'compressSpaces'); }
    return 'P:' + paperType_ID;
  }

  getLanguageString(value: string): string {
    if (!value) { return ''; }
    return LanguagePipe.get(value, 'compressSpaces');
  }
}
